import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ebd9a2b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "convertNum"
}
const _hoisted_2 = { class: "textBox" }
const _hoisted_3 = {
  key: 0,
  class: "cardTitle"
}
const _hoisted_4 = {
  key: 1,
  class: "cardTitle"
}
const _hoisted_5 = {
  key: 2,
  class: "cardCentent"
}
const _hoisted_6 = { class: "cardtype" }
const _hoisted_7 = {
  key: 3,
  class: "cardCentent"
}
const _hoisted_8 = { class: "cardtype" }
const _hoisted_9 = { class: "cardScore" }
const _hoisted_10 = { class: "btnBox" }
const _hoisted_11 = {
  key: 0,
  class: "countdown"
}

import { ref, computed, watch } from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import store from "@/store";
import { convertScore } from "@/api/pointsMall";
import i18n from "@/lang";
import { useRouter } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'cards',
  props: {
  cardData: {
    type: Object,
    default: {},
  },
},
  emits: ["getScoreData"],
  setup(__props, { emit: emits }) {

const props = __props

const goodname = ref();
const goodprice = ref();
const router = useRouter();
const $t = i18n.global.t;

const countdownTimer = ref();
const isMobile = computed(() => store.state.isMobile);
const appLanguage: any = computed(() => store.getters.getAppLanguage);
const countdownTime: any = ref();
const timer = () => {
  if (countdownTime.value >= 0 && countdownTime.value < 86400000) {
    countdownTimer.value = setInterval(() => {
      countdownTime.value = countdownTime.value - 1000;
      if (countdownTime.value == 0) {
        clearInterval(countdownTimer.value);
      }
    }, 1000);
  }
};
const countdown = () => {
  if (!props.cardData.offTime || !props.cardData.currentTime) {
    return false;
  }
  let offTime: any = new Date(props.cardData.offTime.replace(/-/g, "/"));
  let currentTime: any = new Date(
    props.cardData.currentTime.replace(/-/g, "/")
  );
  countdownTime.value = offTime - currentTime;
  timer();
};
const goodsContent = ref();
watch(
  () => props.cardData,
  () => {
    goodsContent.value = props.cardData.goodsContent;
    countdown();
  },
  { deep: true, immediate: true }
);
watch(
  () => appLanguage,
  () => {
    goodname.value =
      appLanguage.value == "en"
        ? props.cardData.goodsNameEn
        : props.cardData.goodsName;
    goodprice.value = props.cardData.goodsPrice;
  },
  { deep: true, immediate: true }
);

const formatTime = (msTime: number) => {
  let time = msTime / 1000;

  let hour: any = Math.floor(time / 60 / 60);

  hour = hour.toString().padStart(2, "0");

  let minute: any = Math.floor(time / 60) % 60;

  minute = minute.toString().padStart(2, "0");

  let second: any = Math.floor(time) % 60;

  second = second.toString().padStart(2, "0");

  return `${hour}:${minute}:${second}`;
};

// 兑换商品
// 兑换商品个数
const purchaseQuantity = ref(1);
const AppCode: string = "dec";

const getConvertScore = () => {
  convertScore({
    appCode: AppCode,
    goodsId: props.cardData.id,
    goodsPrice: props.cardData.goodsPrice,
    orderAmount: props.cardData.goodsPrice * purchaseQuantity.value,
    orderCount: purchaseQuantity.value,
  }).then((res) => {
    if (res.code == 0) {
      ElMessage.success($t("pointsMall.successfully"));
    } else if (res.code == 1 && res.errorCode == "VEAN012") {
      ElMessageBox.confirm(
        $t("pointsMall.dialogText", {
          goodname: goodname.value,
          goodprice: goodprice.value,
        }),
        $t("gift.balance_title"),
        {
          dangerouslyUseHTMLString: true,
          // center: true,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          cancelButtonText: $t("pointsMall.how"),
          confirmButtonText: $t("pointsMall.btn"),
          showClose: false,
          customClass: isMobile.value
            ? "pointsMallConfirm"
            : "pointsMallConfirmPc",
          cancelButtonClass: "cancelBtn",
          confirmButtonClass: "confirmBtn",
        }
      )
        .then((res) => {})
        .catch((res) => {
          if (!isMobile.value) {
            store.commit("howToGetScoreState", true);
          } else {
            router.push("/rewards/article");
          }
        });
    } else {
      ElMessage.warning(res.msg);
    }
    emits("getScoreData");
  });
};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(isMobile) ? 'cardsBoxM' : 'cardsBoxPc')
  }, [
    (__props.cardData.goodsCount !== null && __props.cardData.goodsEveryoneCount !== -1)
      ? (_openBlock(), _createElementBlock("b", _hoisted_1, _toDisplayString(__props.cardData.myBuyedCount ? __props.cardData.myBuyedCount : 0) + "/" + _toDisplayString(__props.cardData.goodsEveryoneCount), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (_unref(appLanguage) == 'zh')
        ? (_openBlock(), _createElementBlock("h2", _hoisted_3, _toDisplayString(__props.cardData.goodsName), 1))
        : _createCommentVNode("", true),
      (_unref(appLanguage) == 'en')
        ? (_openBlock(), _createElementBlock("h2", _hoisted_4, _toDisplayString(__props.cardData.goodsNameEn), 1))
        : _createCommentVNode("", true),
      (__props.cardData.goodsType == 'tm')
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
            _createElementVNode("span", {
              class: _normalizeClass(["cardnum", !_unref(isMobile) && _unref(appLanguage) == 'en' ? 'pcCard' : ''])
            }, _toDisplayString(__props.cardData.goodsContent), 3),
            _createElementVNode("span", _hoisted_6, _toDisplayString(_unref($t)("pointsMall.day")), 1)
          ]))
        : _createCommentVNode("", true),
      (__props.cardData.goodsType == 'ty')
        ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
            _createElementVNode("span", {
              class: _normalizeClass(["cardnum", !_unref(isMobile) && _unref(appLanguage) == 'en' ? 'pcCard' : ''])
            }, _toDisplayString(__props.cardData.goodsContent), 3),
            _createElementVNode("span", _hoisted_8, _toDisplayString(_unref($t)("pointsMall.deviceMonths")), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("span", _hoisted_9, _toDisplayString(__props.cardData.goodsPrice) + " " + _toDisplayString(_unref($t)("pointsMall.score")), 1)
    ]),
    _createElementVNode("div", _hoisted_10, [
      (
          __props.cardData.offTime != null &&
          __props.cardData.currentTime != null &&
          0 < countdownTime.value &&
          countdownTime.value < 86400000
        )
        ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_unref($t)("pointsMall.time", {
            offTime: formatTime(countdownTime.value),
          })), 1))
        : _createCommentVNode("", true),
      _createVNode(_component_el_button, {
        class: "cardBtn",
        onClick: getConvertScore,
        disabled: __props.cardData.myBuyedCount == __props.cardData.goodsEveryoneCount
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref($t)("pointsMall.Exchange")), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ])
  ], 2))
}
}

})